import React from "react";
import { RouteProps } from "react-router-dom";
import Button from "../../../components/Form/Button";
import Form from "../components/Form";
import { IUser } from "../../../services/api/User";
import { IGroup } from "../../../services/api/Group";
import { IProfile } from "../../../services/api/Profile";

interface UserListProps extends RouteProps {
  data: IUser[];
  profiles: IProfile[];
  groups: IGroup[];
}

function toggleForm(e: any) {
  e.target.nextElementSibling.classList.toggle("form--open");
  e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.toggle(
    "form--open"
  );
}

const UserList: React.FC<UserListProps> = ({ data, profiles, groups }) => {
  function renderRow(user: IUser) {
    return (
      <tr key={user.id}>
        <td className="table__data--border">{user.name}</td>
        <td>{user.email}</td>
        <td>{user.profile.name}</td>
        <td>{user.group.name}</td>
        <td>
          <Button className="button-edit" title="Edit" onClick={toggleForm} />
          <div className="form--float">
            <Form userEdit={user} profiles={profiles} groups={groups} />
          </div>
        </td>
      </tr>
    );
  }

  return (
    <React.Fragment>
      <div className="table">
        <table className="table__data">
          <thead>
            <tr>
              <th>Name</th>
              <th>E-mail</th>
              <th>Profile</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>{data.map(renderRow)}</tbody>
        </table>
      </div>
    </React.Fragment>
  );
};

export default UserList;
